<template>
  <div class="gradient-bar" :style="{ width }">
    <div class="unit">{{ unit }}</div>
    <div class="gradient-wrap">
      <div class="drawing-board" :style="style"></div>
      <span class="label" v-for="item in scale" :key="item.key" :style="{ bottom: item.bottom }">
        {{ item.label }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '80px'
    },
    gradient: {
      type: [String, Object],
      default: ''
    },
    max: {
      type: Number,
      default: 100
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultGradient: {
        0: 'rgba(0,0,128,0)',
        0.125: 'rgba(0,4,255,1)',
        0.376: 'rgb(2,255,255)',
        0.62: 'rgba(254,255,1,1)',
        0.87: 'rgba(255,0,0,1)',
        '1.0': 'rgba(130,0,0,1)'
      }
    };
  },
  computed: {
    style() {
      let gradientText = [];
      const gradient = this.getGradient();
      Object.keys(gradient)
        .sort((a, b) => a - b)
        .forEach(e => {
          gradientText.push(`${gradient[e]} ${e * 100}%`);
        });
      gradientText = gradientText.join(',');
      return {
        backgroundImage: `linear-gradient(0deg, transparent 0%, ${gradientText})`
      };
    },
    scale() {
      const gradient = this.getGradient();
      let max = this.max || gradient.max || 100;
      const res = [];
      for (let index = 0; index <= 5; index++) {
        const t = (index * 2) / 10;
        res.push({
          label: `${parseInt(t * max)}`,
          key: index,
          bottom: `${t * 100}%`
        });
      }
      return res;
    }
  },
  methods: {
    getGradient() {
      try {
        if (typeof this.gradient === 'string') return JSON.parse(this.gradient);
        return this.gradient || this.defaultGradient;
      } catch (err) {
        return this.defaultGradient;
      }
    },
    showTips() {
      if (this.tipsVisible) return;
      this.tipsVisibility = true;
    },
    hideTips() {
      this.tipsVisibility = false;
    }
  }
};
</script>

<style lang="scss">
.gradient-bar {
  display: inline-block;
  position: relative;
  z-index: 20;
  padding: 10px 0px 20px 5px;
  background: rgba(192, 192, 192, 0.4);
  border-radius: 4px;

  .gradient-wrap {
    position: relative;
    width: 30px;
    height: 100%;
  }

  .unit {
    color: #000;
    margin-bottom: 10px;
  }

  .drawing-board {
    height: 100px;
    box-shadow: 0 0 0px 3px #fff;
  }
  .tips {
    width: 30px;
    text-align: right;
    position: absolute;
    left: -32px;
    color: rgb(12, 22, 32);
  }
  .label {
    display: inline-block;
    width: 40px;
    position: absolute;
    text-align: left;
    right: -46px;
    color: rgb(12, 22, 32);
    transform: translateY(50%);
  }
}
</style>
